module.exports = __webpack_public_path__ + "static/media/logo-nav.54a76875.svg";